import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFilterButtonIcon } from 'shared/UI/UIKit/icons/FilterButton';
import { AppSider } from 'shared/UI/UIKit/Sider';
import type { TableFilterField } from './types';
import { useTableFilter } from './use-table-filter';
import styles from './TableFilter.module.scss';
import { TableFilterForm } from './TableFilterForm';

interface TableFilterProps {
  fields: TableFilterField[];
  onFilterChange: (values: Record<string, any>) => void;
  onLoadOptions?: (fieldName: string) => void;
  siderClassName?: string;
}

export const TableFilter = ({
  fields,
  onFilterChange,
  onLoadOptions,
  siderClassName,
}: TableFilterProps) => {
  const {
    state: { siderVisible, filterState, filterCount },
    methods: { showSider, hideSider, onSubmit },
  } = useTableFilter({ onFilterChange });

  return (
    <>
      <AppButton type="outline" className={styles.button} onClick={showSider}>
        <AppFilterButtonIcon className={styles.icon} />
        Фильтры
        {!!filterCount && <div className={styles.count}>{filterCount}</div>}
      </AppButton>
      <AppSider
        title="Фильтры"
        isSiderVisible={siderVisible}
        submitBtnText="Применить"
        cancelBtnText="Сбросить всё"
        hideSider={hideSider}
        rootClassName={siderClassName}
      >
        <TableFilterForm
          fields={fields}
          fieldsValue={filterState}
          onSubmit={onSubmit}
          onClose={hideSider}
          onLoadOptions={onLoadOptions}
        />
      </AppSider>
    </>
  );
};
